import {Dispatch} from "redux";
import {IResponse, RACARequest} from "../../Request";
import {endLoading, startLoading} from "../../../store/slices/loadingSlice";
import requestMiddlewares from "../../requestMiddlewares";
import {setSession} from "../../../store/slices/sessionSlice";

export interface ISignUpRequest {
  name: string;
  lastName: string;
  email: string;
  password: string;
  role: string;
}

export default async function signUpRequest(
  dispatch: Dispatch,
  data: ISignUpRequest,
): Promise<IResponse> {
  dispatch(startLoading());

  const request = new RACARequest('auth', 'signup')
    .setData(data);

  const response = await request.makeRequest();

  requestMiddlewares(
    dispatch,
    response,
  );

  dispatch(endLoading());

  return response;
}
